// Puslapių peržiūrų sekimas — kviečiama VIENĄ kartą prie App šaknies (žr.
// App.js). Kiekvienam maršruto pasikeitimui: 1) praneša ANKSTESNIO puslapio
// trukmę (sendBeacon, žr. src/utils/analytics.js), 2) užregistruoja NAUJĄ
// pageview įvykį. Taip pat pagauna pačio PASKUTINIO puslapio trukmę per
// visibilitychange/pagehide, kai lankytojas iš viso išeina iš svetainės (ne tik
// pereina tarp puslapių) — be šito paskutinio apsilankyto puslapio trukmė
// niekada nebūtų sužinota.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { postAnalyticsSession, trackEvent, sendPageviewDuration, initGlobalClickTracking } from '../utils/analytics';

export const useAnalyticsPageviews = () => {
  const location = useLocation();
  const currentRef = useRef(null); // { eventId, enteredAt }

  // Sesijos inicijavimas + globalus paspaudimų sekimas — VIENĄ kartą per visą
  // programos gyvavimą, ne kiekvieną maršruto pasikeitimą.
  useEffect(() => {
    postAnalyticsSession();
    const stopClicks = initGlobalClickTracking();
    return stopClicks;
  }, []);

  // Praneša esamo (prieš pat pakeičiant) puslapio trukmę, jei toks yra.
  const flushCurrent = () => {
    const cur = currentRef.current;
    if (cur?.eventId) sendPageviewDuration(cur.eventId, Date.now() - cur.enteredAt);
    currentRef.current = null;
  };

  useEffect(() => {
    flushCurrent();
    // /konfiguratorius nesekamas apskritai — nei pageview, nei trukmė (žr.
    // /admin/bugs dėl sulėtėjimo ir vartotojo prašymo "isimk statistikos
    // rinkima is /konfiguratorius puslapio"). Kitiems puslapiams sekimas
    // lieka nepakitęs.
    if (location.pathname.startsWith('/konfiguratorius')) return;
    const path = location.pathname + location.search;
    let cancelled = false;
    trackEvent('pageview', { path }).then((eventId) => {
      if (cancelled) return;
      currentRef.current = { eventId, enteredAt: Date.now() };
    });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search]);

  // Lankytojas išeina iš svetainės VISIŠKAI (uždaro kortelę, pereina į kitą
  // domeną) — tab pakeitimas irgi sukelia visibilitychange, bet 'hidden' ten
  // tinka lygiai taip pat gerai (grįžus rodoma TA PATI trukmė iki tol, o nauja
  // pageview neprasideda, kol trukmė realiai neatsinaujina).
  useEffect(() => {
    const onHide = () => {
      if (document.visibilityState === 'hidden') flushCurrent();
    };
    window.addEventListener('visibilitychange', onHide);
    window.addEventListener('pagehide', flushCurrent);
    return () => {
      window.removeEventListener('visibilitychange', onHide);
      window.removeEventListener('pagehide', flushCurrent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
